import {StepDataProvider} from 'components/common/CartItemBuilder/providers/StepDataProvider'
import {VentrataDataProvider} from 'components/common/CartItemBuilder/providers/VentrataDataProvider'
import {Warning} from 'components/system/Warning'
import {useMemo} from 'react'
import {Counter} from './Counter/Counter'

type Props = {
  unitId: string
  isMaxNumberOfGuestsForOptionExeeded: boolean
}

export const Guest = ({unitId, isMaxNumberOfGuestsForOptionExeeded}: Props) => {
  const unit = VentrataDataProvider.useUnit(unitId, 'optional')
  const unitCounter = StepDataProvider.guests.useUnitCounter(unit.id)

  const maxGuestsForUnit = useMemo(() => {
    return unit.restrictions?.maxQuantity
  }, [unit])

  const isMaxNumberOfGuestsForUnitExeeded = useMemo(() => {
    return Boolean(maxGuestsForUnit && maxGuestsForUnit === unitCounter)
  }, [maxGuestsForUnit, unitCounter])

  return (
    <div className="flex flex-col gap-2">
      <div className="flex justify-between items-center">
        <div className="flex flex-col ">
          <div className="font-bold">{unit.title}</div>
          <div className="font-sm text-french-blue-020">{unit.subtitle}</div>
        </div>

        <div className="flex gap-6 items-center text-lg">
          <Counter
            unit={unit}
            isMaxNumberOfGuestsForOptionExeeded={isMaxNumberOfGuestsForOptionExeeded}
            isMaxNumberOfGuestsForUnitExeeded={isMaxNumberOfGuestsForUnitExeeded}
          />
        </div>
      </div>
      {isMaxNumberOfGuestsForUnitExeeded && (
        <Warning>You've added the maximum number of guests for this unit ({maxGuestsForUnit})</Warning>
      )}
    </div>
  )
}
